import { Layout as RALayout, CheckForApplicationUpdate } from "react-admin";
import Menu from "./Menu";
import AppBar from "./AppBar";

const Layout = ({ children }) => {
  return (
    <RALayout menu={Menu} appBar={AppBar}>
      {children}
      <CheckForApplicationUpdate />
    </RALayout>
  );
};

export default Layout;
